import { InfoIcon } from '../../../../../../../assets/svg/info';
import { DatePeriod } from '../../../../../../../features/date-time/date-picker/date-picker-calendar/use-date-picker-calendar';
import { Tooltip } from '../../../../../../../features/tooltip/tooltip';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../../hooks/use-query-params';
import { ShiftType } from '../../../../../../../store/api/shifts-api';
import { ShiftsGridMonthly } from '../../shifts-grid/shifts-grid-monthly/shifts-grid-monthly';
import { ShiftsGridWeekly } from '../../shifts-grid/shifts-grid-weekly/shifts-grid-weekly';
import { shiftStatusRecord, ShiftStatusType } from '../../shifts-grid/shifts-helpers';
import s from './shifts-dates-info.module.css';

const date = '2023-10-01T09:00:00';

const employee: ShiftType['staff'] = {
  id: -1,
  name: { ru: 'Иван' },
  surname: { ru: 'Иванов' },
  tags: [],
  places: [],
};

const baseShift: ShiftType = {
  id: '-1',
  start_time: '2023-10-01T09:00:00',
  end_time: '2023-10-01T18:00:00',
  staff: employee,
  checkin: {
    id: -1,
    end_time: '2023-10-01T09:00:00',
    start_time: '2023-10-01T09:00:00',
    staff: employee,
    shift: null,
  },
};

const shiftsRecord: Record<ShiftStatusType, ShiftType | undefined> = {
  'red-red': {
    ...baseShift,
    checkin: {
      ...baseShift.checkin!,
      start_time: '2023-10-01T10:00:00',
      end_time: '2023-10-01T15:00:00',
    },
  },
  'green-green': {
    ...baseShift,
    checkin: {
      ...baseShift.checkin!,
      start_time: '2023-10-01T08:00:00',
      end_time: '2023-10-01T19:00:00',
    },
  },
  'green-red': {
    ...baseShift,
    checkin: {
      ...baseShift.checkin!,
      start_time: '2023-10-01T08:00:00',
      end_time: '2023-10-01T15:00:00',
    },
  },
  'red-green': {
    ...baseShift,
    checkin: {
      ...baseShift.checkin!,
      start_time: '2023-10-01T12:00:00',
      end_time: '2023-10-01T21:00:00',
    },
  },
  absent: {
    ...baseShift,
    checkin: undefined,
  },
  'no-schedule': undefined,
  planned: {
    ...baseShift,
    checkin: {
      ...baseShift.checkin!,
      start_time: '2023-10-01T09:00:00',
      end_time: '2023-10-01T18:00:00',
    },
  },
};

export const ShiftsDatesInfo = () => {
  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const { t } = useLang();

  const period = params.period as DatePeriod;

  return (
    <Tooltip
      triggerWrapperClassName={s.trigger}
      optionsWrapperClassName={s.wrapper}
      wrapperClassName={s.feature}
      trigger={
        <>
          <InfoIcon />
          {t('Что обозначают иконки?')}
        </>
      }
    >
      <ul className={s.list}>
        {Object.entries(shiftsRecord).map(([key, shift]) => {
          const shifts = shift ? [shift] : [];
          const employeeShifts = { ...employee, shifts };

          return (
            <li key={key} className={s.item}>
              {period === 'month' ? (
                <ShiftsGridMonthly
                  date={date}
                  employee={employeeShifts}
                  className={s.month}
                  status={key as ShiftStatusType}
                />
              ) : (
                <ShiftsGridWeekly
                  date={date}
                  employee={employeeShifts}
                  className={s.week}
                  status={key as ShiftStatusType}
                />
              )}
              {t(shiftStatusRecord[key as ShiftStatusType])}
            </li>
          );
        })}
      </ul>
    </Tooltip>
  );
};
